import {
  Element,
  ElementAnswer,
  ElementOption,
  ElementVendorQuestion,
  SectionGroup,
} from "./RfiTypes";

class RfiElement {
  elementId: number;
  rfiElementLink?: string;
  previousElementId?: string;
  isDirty?: boolean | undefined;
  sections?: SectionGroup[] | undefined | null;
  customerId?: number;
  elementType: string;
  fieldType: string;
  fieldLabel: string;
  editLabel?: boolean | undefined;
  lookupCode?: string;
  customerRequired?: boolean | undefined;
  requiredInRfi?: boolean | undefined;
  requiredResponse?: boolean | undefined;
  editRequired?: boolean | undefined;
  rfiId?: number;
  mapsToField?: string;
  dateCreated?: string;
  dateLastEdited?: string;
  lastUpdatedUserId?: number;
  options?: ElementOption[] | undefined | null;
  answers?: ElementAnswer[] | undefined | null;
  vendorQuestions?: ElementVendorQuestion[] | undefined | null | [];
  hasValueChanged?: boolean | undefined;
  endpoint?: string;

  constructor(element: Element) {
    this.elementId = element.elementId;
    this.rfiElementLink = element.rfiElementLink;
    this.previousElementId = element.previousElementId;
    this.isDirty = element.isDirty;
    this.sections = element.sections;
    this.customerId = element.customerId;
    this.elementType = element.elementType;
    this.fieldType = element.fieldType;
    this.fieldLabel = element.fieldLabel;
    this.editLabel = element.editLabel;
    this.lookupCode = element.lookupCode;
    this.mapsToField = element.mapsToField;
    this.customerRequired = element.customerRequired;
    this.requiredInRfi = element.requiredInRfi;
    this.requiredResponse = element.requiredResponse;
    this.editRequired = element.editRequired;
    this.dateCreated = element.dateCreated;
    this.dateLastEdited = element.dateLastEdited;
    this.lastUpdatedUserId = element.lastUpdatedUserId;
    this.options = element.options;
    this.answers = element.answers;
    this.vendorQuestions = element.vendorQuestions;
    this.rfiId = element.rfiId;
    this.hasValueChanged = false;
  }

  //  setValues(values: ElementAnswer[]) {
  //    this.answers = values;
  //    this.hasValueChanged = true;

  //  }

  clearHasChanged() {
    this.hasValueChanged = false;
  }
}

export default RfiElement;
